import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'en', component: HomeComponent },
  { path: 'pt', component: HomeComponent },
  { path: '**', redirectTo: 'en', pathMatch: 'full' },
];
